import { DataGridLayout, List, ListHeader, ListPageLayout } from 'framework/list';
import ViewAccountingCycleButton from '../shared/button/ViewAccountingCycleButton';
import useAccountingCycle, { ACCOUNTING_CYCLE_OPTIONS } from '../useAccountingCycle';
import { DateField, EnumField, SearchLinkField } from 'framework/ui/field';
import { useAccountingCycleUrl } from '../shared/useAccountingCycleRouting';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';

const AccountingCycleList = () => {
  const { search } = useAccountingCycle();
  const { getSingleEntityUrl } = useAccountingCycleUrl();

  return (
    <List getDataMethod={search}>
      <ListPageLayout header={<ListHeader label="Accounting Cycles" icon="fa-folder-o" />}>
        <DataGridLayout buttons={[<ViewAccountingCycleButton source="id" />]}>
          <SearchLinkField source="id" label="ID" url={getSingleEntityUrl} width={140} isSortable />
          <EnumField label="Status" source="status" options={ACCOUNTING_CYCLE_OPTIONS} isSortable />
          <DateField source="closedAt" label="Closed at" isSortable />
          <EmployeeLinkFieldWithNameLoading label="Closed by" source="closedBy" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default AccountingCycleList;
